define(function (require) {
    'use strict';

    //var CentrifugoConnection = require('modules/websocket/centrifugo/connection');
    //var SocketIoConnection   = require('modules/websocket/io/connection');
    var SocketNotifyConnection   = require('modules/websocket/notify/connection');

    return {
        //createCetrifugoConnection: function (properties) {
        //    return new CentrifugoConnection(properties).connect();
        //},

        //createSocketIoConnection: function (properties) {
        //    return new SocketIoConnection(properties).connect();
        //},

        createNotifyConnection: function (properties) {
            return new SocketNotifyConnection(properties).connect();
        }
    };
});